module.exports = __webpack_public_path__ + "media/3.5c8e8030.wav";